import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { IApiResponse, IChatMessage } from "app/models/interfaces";
import { HttpInterceptorApi } from "./api.service";
import { createHttpClient } from "@fuse/services/http-client.factory";

@Injectable({
  providedIn: 'root',
})
export class ChatboxService {

  private httpWithoutLoader: HttpClient;

  constructor(
    private injector: Injector
  ) {
    this.httpWithoutLoader = createHttpClient(this.injector, [
      HttpInterceptorApi,
    ]);
  }

  public getChatHistory(): Observable<IApiResponse<IChatMessage[]>> {
    return this.httpWithoutLoader.get<IApiResponse<IChatMessage[]>>('API/chatbox/chat-history');
  }
}